"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableColumnConfig = exports.getSelectedFolder = exports.getPortalUrlFromPortal = exports.getItemOrgPageUrl = exports.getItemGroups = exports.getItemGroupSearchUrl = exports.getFilterGroupItems = exports.getActiveFilterItem = exports.formatUrlParamUpdates = exports.createAccountKey = exports.browserViewTitles = void 0;
var _stateTypes = _interopRequireDefault(require("../store/stateTypes"));
var _arcgisRestRequest = require("@esri/arcgis-rest-request");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var getFilterGroupItems = function getFilterGroupItems(_ref) {
  var items = _ref.items,
    groupId = _ref.groupId;
  return items.allIds.reduce(function (acc, id) {
    if (items.byId[id].group === groupId) {
      acc.push(items.byId[id]);
    }
    return acc;
  }, []);
};
exports.getFilterGroupItems = getFilterGroupItems;
var getSelectedFolder = function getSelectedFolder(state) {
  if (state) {
    var selectedFolder = Object.values(state.folders.items.byId).find(function (folder) {
      return folder.state === _stateTypes.default.FOLDER_ITEM_ACTIVE;
    });
    if (selectedFolder) return selectedFolder;
    return null;
  }
  return null;
};
exports.getSelectedFolder = getSelectedFolder;
var getActiveFilterItem = function getActiveFilterItem(filters) {
  var activeFilterItem = Object.values(filters === null || filters === void 0 ? void 0 : filters.items.byId).filter(function (filter) {
    return filter.state === _stateTypes.default.FILTER_ITEM_ACTIVE;
  });
  return activeFilterItem;
};
exports.getActiveFilterItem = getActiveFilterItem;
var createAccountKey = function createAccountKey(_ref2) {
  var username = _ref2.username,
    portalName = _ref2.portalName;
  try {
    var orgName = portalName ? portalName.replace(/\s+/g, "") : "org";
    var key = username + "-" + orgName;
    return key;
  } catch (err) {
    console.error(err);
    return undefined;
  }
};
exports.createAccountKey = createAccountKey;
var formatUrlParamUpdates = function formatUrlParamUpdates(_ref3) {
  var updatedState = _ref3.updatedState,
    urlParams = _ref3.urlParams;
  var formattedUrlParams = {
    folder: null,
    num: null,
    start: null,
    sortField: null,
    sortOrder: null,
    focus: null,
    modified: null,
    uploaded: null,
    modified_from: null,
    modified_to: null,
    uploaded_from: null,
    uploaded_to: null,
    searchTerm: null
  };
  if (urlParams.get) {
    Object.keys(formattedUrlParams).forEach(function (key) {
      formattedUrlParams[key] = urlParams.get(key);
    });
  }

  // Gets currently selected folder
  var selectedFolder = updatedState.folders.items.allIds.find(function (id) {
    return updatedState.folders.items.byId[id].state === _stateTypes.default.FOLDER_ITEM_ACTIVE;
  }) || null;
  formattedUrlParams.folder = selectedFolder;
  // Checks to see if modified FilterItem is active
  var modifiedActive = updatedState.filters.items.allIds.find(function (id) {
    return id.includes("modified") && updatedState.filters.items.byId[id].state === _stateTypes.default.FILTER_ITEM_ACTIVE;
  });

  // Checks to see if custom-modified is active. If so, add to formattedUrlParams.
  var customModifiedKey = updatedState.filters.items.allIds.find(function (id) {
    return id === "custom-modified";
  });
  var customModifiedItem = updatedState.filters.items.byId[customModifiedKey];
  if (customModifiedItem.state === _stateTypes.default.FILTER_ITEM_ACTIVE && customModifiedItem.startDate && customModifiedItem.endDate) {
    formattedUrlParams.modified_from = customModifiedItem.startDate;
    formattedUrlParams.modified_to = customModifiedItem.endDate;
  }

  // Checks to see if custom-created is active. If so, add to formattedUrlParams.
  var customCreatedKey = updatedState.filters.items.allIds.find(function (id) {
    return id === "custom-created";
  });
  var customCreatedItem = updatedState.filters.items.byId[customCreatedKey];
  if (customCreatedItem.state === _stateTypes.default.FILTER_ITEM_ACTIVE && customCreatedItem.startDate && customCreatedItem.endDate) {
    formattedUrlParams.uploaded_from = customCreatedItem.startDate;
    formattedUrlParams.uploaded_to = customCreatedItem.endDate;
  }

  // Checks to see if created FilterItem is active
  var createdActive = updatedState.filters.items.allIds.find(function (id) {
    return id.includes("created") && updatedState.filters.items.byId[id].state === _stateTypes.default.FILTER_ITEM_ACTIVE;
  });

  // Checks to see if item type FilterItem is active
  var itemTypeFilterActive = updatedState.filters.items.allIds.find(function (id) {
    return !id.includes("modified") && !id.includes("created") && updatedState.filters.items.byId[id].state === _stateTypes.default.FILTER_ITEM_ACTIVE;
  });

  // Checks to see if item type FilterItemOption is active
  var itemOptionTypeFilterActive = updatedState.filters.itemOptions.allIds.find(function (id) {
    return updatedState.filters.itemOptions.byId[id].group === itemTypeFilterActive && updatedState.filters.itemOptions.byId[id].state === _stateTypes.default.FILTER_ITEM_OPTION_ACTIVE;
  });

  // If any of the above FilterItems/FilterItemOptions in 3 FilterGroups are active, update URL params

  if (modifiedActive) formattedUrlParams.modified = modifiedActive.split("-")[0];
  if (createdActive) formattedUrlParams.uploaded = createdActive.split("-")[0];
  if (itemTypeFilterActive) formattedUrlParams.focus = updatedState.filters.items.byId[itemTypeFilterActive].urlField;
  if (itemOptionTypeFilterActive) formattedUrlParams.focus = "".concat(formattedUrlParams.focus, "-").concat(updatedState.filters.itemOptions.byId[itemOptionTypeFilterActive].urlField);
  if (updatedState.searchTerm) {
    formattedUrlParams.searchTerm = updatedState.searchTerm;
  }
  return formattedUrlParams;
};
exports.formatUrlParamUpdates = formatUrlParamUpdates;
var browserViewTitles = {
  content: "My Content",
  organization: "My Organization",
  online: "ArcGIS Online",
  resources: "Resources"
};
exports.browserViewTitles = browserViewTitles;
var getPortalUrlFromPortal = function getPortalUrlFromPortal(portal) {
  if ((portal === null || portal === void 0 ? void 0 : portal.isPortal) === false && (portal === null || portal === void 0 ? void 0 : portal.id)) {
    return "https://".concat(portal.urlKey, ".").concat(portal.customBaseUrl);
  } else if ((portal === null || portal === void 0 ? void 0 : portal.isPortal) === true) {
    return "https://".concat(portal.portalHostname);
  }
  return "https://www.arcgis.com";
};
exports.getPortalUrlFromPortal = getPortalUrlFromPortal;
var getItemOrgPageUrl = function getItemOrgPageUrl(portal, itemId) {
  var portalUrl = getPortalUrlFromPortal(portal);
  var itemOrgPageUrl = "".concat(portalUrl, "/home/item.html?id=").concat(itemId);
  return itemOrgPageUrl;
};
exports.getItemOrgPageUrl = getItemOrgPageUrl;
var getItemGroupSearchUrl = function getItemGroupSearchUrl(_ref4) {
  var portal = _ref4.portal,
    itemIds = _ref4.itemIds,
    groupIds = _ref4.groupIds;
  var portalUrl = getPortalUrlFromPortal(portal);
  var itemGroupSearchUrl = "".concat(portalUrl, "/sharing/rest/content/itemsgroups?items=").concat(itemIds, "&groups=").concat(groupIds);
  return itemGroupSearchUrl;
};
exports.getItemGroupSearchUrl = getItemGroupSearchUrl;
var getItemGroups = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref5) {
    var portal, itemIds, groupIds, authentication, url, options, itemGroups, allItemIds;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            portal = _ref5.portal, itemIds = _ref5.itemIds, groupIds = _ref5.groupIds, authentication = _ref5.authentication;
            _context.prev = 1;
            if (!(itemIds && groupIds)) {
              _context.next = 10;
              break;
            }
            url = getItemGroupSearchUrl({
              portal: portal,
              itemIds: itemIds,
              groupIds: groupIds
            });
            options = {
              authentication: authentication
            };
            _context.next = 7;
            return (0, _arcgisRestRequest.request)(url, options);
          case 7:
            itemGroups = _context.sent;
            allItemIds = Object.keys(itemGroups).reduce(function (acc, key) {
              var _itemGroups$key = itemGroups[key],
                items = _itemGroups$key.items,
                groupId = _itemGroups$key.groupId,
                groupTitle = _itemGroups$key.groupTitle;
              var groupObj = {
                groupId: groupId,
                groupTitle: groupTitle,
                // groupLetter displays first letter in group title to be used in group icon in ItemTable
                groupLetter: groupTitle.charAt(0).toUpperCase()
              };
              items.forEach(function (item) {
                if (!acc[item.itemId]) {
                  acc[item.itemId] = [];
                }
                acc[item.itemId].push(groupObj);
              });
              return acc;
            }, {});
            return _context.abrupt("return", allItemIds);
          case 10:
            return _context.abrupt("return", null);
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.warn(_context.t0);
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return function getItemGroups(_x) {
    return _ref6.apply(this, arguments);
  };
}();
exports.getItemGroups = getItemGroups;
var tableColumnConfig = [{
  dataKey: "title",
  label: "Title",
  flexBasis: 500,
  id: "title",
  filterable: true
}, {
  dataKey: "type",
  label: "Type",
  flexBasis: 200,
  id: "type",
  filterable: true
}, {
  dataKey: "owner",
  label: "Owner",
  flexBasis: 200,
  id: "owner",
  filterable: true
}, {
  dataKey: "",
  label: "",
  flexBasis: 200,
  id: "sharing",
  filterable: false
}, {
  dataKey: "",
  label: "",
  flexBasis: 200,
  id: "actions",
  filterable: false
}, {
  dataKey: "created",
  label: "Created",
  flexBasis: 200,
  id: "created",
  filterable: true
}, {
  dataKey: "modified",
  label: "Modified",
  flexBasis: 200,
  id: "modified",
  filterable: true
}];
exports.tableColumnConfig = tableColumnConfig;